module.exports = __webpack_public_path__ + "static/features1-8c66f7e30d84e99b4925982a6395393e.png";